/**
 * Formata o tipo de embarque conforme o modal de transporte.
 * Marítimo (e demais) usa o valor bruto (ex.: FCL/LCL) ou "Não informado".
 */
export function formatTypeOfBoarding(wayOfTransport, typeOfBoarding) {
  const modal = (wayOfTransport || "").toUpperCase();

  if (modal === "AEREA") {
    return "Aéreo";
  }
  if (modal === "RODOVIARIA") {
    return "Rodoviário";
  }
  if (modal === "FLUVIAL") {
    return "Fluvial";
  }

  return typeOfBoarding != null && typeOfBoarding !== ""
    ? typeOfBoarding
    : "Não informado";
}
